import { uiText } from '@/i18n/interface';

import { useToast } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';

export const usePaymentDateManager = () => {
  const { toast } = useToast();

  const updatePaymentDates = async (
    paymentId: string,
    startDate: string,
    endDate: string,
    fetchStudentPayments: () => void
  ) => {
    try {
      const { error } = await supabase
        .from('payment_instructions')
        .update({
          start_date: startDate,
          end_date: endDate
        })
        .eq('id', paymentId);

      if (error) {
        console.error('Error updating payment dates:', error);
        toast({
          title: uiText("Error"),
          description: uiText("Failed to update payment dates"),
          variant: "destructive"
        });
        return;
      }

      toast({
        title: uiText("Dates Updated"),
        description: uiText("Payment dates have been updated successfully")
      });

      fetchStudentPayments();
    } catch (error) {
      console.error('Error updating payment dates:', error);
      toast({
        title: uiText("Error"),
        description: uiText("Failed to update payment dates"),
        variant: "destructive"
      });
    }
  };

  const deletePayment = async (
    paymentId: string,
    fetchStudentPayments: () => void
  ) => {
    try {
      // First, delete any related invoices
      const { error: invoiceError } = await supabase
        .from('invoices')
        .delete()
        .eq('payment_instruction_id', paymentId);

      if (invoiceError) {
        console.error('Error deleting related invoices:', invoiceError);
        toast({
          title: uiText("Error"),
          description: uiText("Failed to delete related invoices"),
          variant: "destructive"
        });
        return;
      }

      // Then delete the payment record
      const { error } = await supabase
        .from('payment_instructions')
        .delete()
        .eq('id', paymentId);

      if (error) {
        console.error('Error deleting payment:', error);
        toast({
          title: uiText("Error"),
          description: uiText("Failed to delete payment record"),
          variant: "destructive"
        });
        return;
      }

      toast({
        title: uiText("Payment Deleted"),
        description: uiText("Payment record and related invoices have been deleted successfully")
      });

      fetchStudentPayments();
    } catch (error) {
      console.error('Error deleting payment:', error);
      toast({
        title: uiText("Error"),
        description: uiText("Failed to delete payment record"),
        variant: "destructive"
      });
    }
  };

  return {
    updatePaymentDates,
    deletePayment
  };
};
